const INIT_CMPL_DOC_FILES = "INIT_CMPL_DOC_FILES";
const SET_CMPL_DOC_FILE = "SET_CMPL_DOC_FILE";
const CHANGE_CMPL_DOC_FILE ="CHANGE_CMPL_DOC_FILE";
const SET_MODIFY_CMPL_DOC_FILE = "SET_MODIFY_CMPL_DOC_FILE";

const initialState = {
  isFirst: true,
  cmplDocFiles: []
};

const custDoc = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case INIT_CMPL_DOC_FILES:
      let _initCmplDocFiles = [];
      return {
        ...state,
        isFirst: true,
        cmplDocFiles: _initCmplDocFiles,
      };
    case SET_CMPL_DOC_FILE:
      return {
        ...state,
        cmplDocFiles: rest.payload.initData,
      };
    case CHANGE_CMPL_DOC_FILE:
      const { docCatCd } = rest.payload

      let newCmplDocFiles = state.cmplDocFiles.map((item) => {
        if(String(item.docCatCd) === String(docCatCd)) {
          return {
            ...item, 
            file: [],
            fileInfo: [],
          };
        } else {
          return item;
        }
      });
    return {
      ...state,
      cmplDocFiles: newCmplDocFiles,
    };
    case SET_MODIFY_CMPL_DOC_FILE:
      const _cmplDocFiles = [];
      const _cmplDocData = rest.payload.cmplDocData || [];
      const _matched = _cmplDocData.map(() => false);   //일치하는지

      state.cmplDocFiles.forEach((cmplDocFile) => {
        if(_cmplDocData.length){
          let existIdx = _cmplDocData.findIndex((item) => Number(item.FORM_CAT_CD) === Number(cmplDocFile.docCatCd) && Number(item.ORD || 1) === Number(cmplDocFile.ord || 1));
          // 인덱스 있으면 == 일치하는 파일이 존재하면 아이템 담아
          if (existIdx > -1) {
              _matched[existIdx] = true;
              const _item = _cmplDocData[existIdx];
              _cmplDocFiles.push({
                ...cmplDocFile,
                file: _item.FILE,
                fileInfo: _item.FILE_INFO,
                update: _item.update,
                realFileNm : _item.realFileNm,
              });
            } else {
              _cmplDocFiles.push(cmplDocFile);
            }
          } else {
            _cmplDocFiles.push(cmplDocFile);
          }

        });
        // 비교설명확인서 두 번째 파일첨부할 때 midPath, custNo 등의 정보들을 첫 번째 파일에서 가져와서 redux 만듦.
      _cmplDocData.forEach((item, i) => {
        if(!_matched[i]){
          const sibling = state.cmplDocFiles.find((f) => Number(f.docCatCd) === Number(item.FORM_CAT_CD)) || {};
          _cmplDocFiles.push({
            custNo: sibling.custNo != null ? sibling.custNo : (item.custNo || null),
            docType: sibling.docType != null ? sibling.docType : (item.docType || null),
            docNo: sibling.docNo != null ? sibling.docNo : (item.docNo || null),
            docCatCd: String(item.FORM_CAT_CD),
            realFileNm: item.realFileNm,
            fileNm: item.fileNm || null,
            midPath: sibling.midPath != null ? sibling.midPath : (item.midPath || null),
            pathChgYn: sibling.pathChgYn != null ? sibling.pathChgYn : (item.pathChgYn || null),
            file: item.FILE,
            fileInfo: item.FILE_INFO,
            update: item.update,
            ord: Number(item.ORD || 1),
          });
        }
      });
      return {
        ...state,
        isFirst: rest.payload.isFirst ? false : state.isFirst,
        cmplDocFiles: _cmplDocFiles,
     };

     
    case "persist/PURGE":
      return initialState;
    default:
      return state;
  }
};

export const initCmplDocFile = () => ({
  type: INIT_CMPL_DOC_FILES,
});
export const setCmplDocFile = (initData) => ({
  type: SET_CMPL_DOC_FILE,
  payload: { initData },
});

export const changeCmplDocFile = (docCatCd) => ({
  type: CHANGE_CMPL_DOC_FILE,
  payload: { docCatCd },
});
export const setModifyCmplDocFile = (cmplDocData, isFirst) => ({
  type: SET_MODIFY_CMPL_DOC_FILE,
  payload: { cmplDocData, isFirst },
});

export default custDoc;
